import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Role } from '../enums/role.enum';
import { AdapterService } from '../services/adapter.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(private readonly router: Router,
    private readonly adaptersService: AdapterService) {

  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const userInfo = this.adaptersService.getLocalStorageValue(environment.storageKeys.userInfo);
      if (userInfo && (userInfo.roleId == Role.FotiouAdmin || userInfo.roleId == Role.CustomerAdmin || userInfo.roleId == Role.FotiouCustomerService))
        return true;

      this.router.navigate(["/product"], { replaceUrl: true });
      return false;
  }
}
